const createTrainingContentLog = ctx => (
  type,
  contentId,
  options = { isFoodSolutionContent: false }
) => {
  ctx.$axios.post('/v3/app/training-content-log', {
    type,
    contentId,
    ...options,
  })
}

export default async (ctx, inject) => {
  inject('createTrainingContentLog', createTrainingContentLog(ctx))
}
